// DO NOT EDIT THIS FILE
// This file has been generated by gen-api-models
// eslint-disable sonar/max-union-size
// eslint-disable sonarjs/no-identical-functions

import * as t from "io-ts";

import * as r from "@pagopa/ts-commons/lib/requests";

import { OidcExchangeRequest } from "./OidcExchangeRequest";

import { OidcExchangeTokenResponse } from "./OidcExchangeTokenResponse";

import { OidcExchangeOtpResponse } from "./OidcExchangeOtpResponse";

import { Problem } from "./Problem";

import { OtpResendRequest } from "./OtpResendRequest";

import { OtpVerifyRequest } from "./OtpVerifyRequest";

import { TokenResponse } from "./TokenResponse";

import { OtpForbidden } from "./OtpForbidden";

/****************************************************************
 * oidcExchange
 */

// Request type definition
export type OidcExchangeT = r.IPostApiRequestType<
  { readonly body?: OidcExchangeRequest | ReadableStream<Uint8Array> | Buffer },
  "Content-Type",
  never,
  | r.IResponseType<200, OidcExchangeTokenResponse, never>
  | r.IResponseType<201, OidcExchangeOtpResponse, never>
  | r.IResponseType<400, Problem, never>
  | r.IResponseType<403, Problem, never>
  | r.IResponseType<404, Problem, never>
  | r.IResponseType<500, Problem, never>
>;

export const oidcExchangeDefaultResponses = {
  200: OidcExchangeTokenResponse,
  201: OidcExchangeOtpResponse,
  400: Problem,
  403: Problem,
  404: Problem,
  500: Problem
};

export type OidcExchangeResponsesT<
  A0 = OidcExchangeTokenResponse,
  C0 = OidcExchangeTokenResponse,
  A1 = OidcExchangeOtpResponse,
  C1 = OidcExchangeOtpResponse,
  A2 = Problem,
  C2 = Problem,
  A3 = Problem,
  C3 = Problem,
  A4 = Problem,
  C4 = Problem,
  A5 = Problem,
  C5 = Problem
> = {
  200: t.Type<A0, C0>;
  201: t.Type<A1, C1>;
  400: t.Type<A2, C2>;
  403: t.Type<A3, C3>;
  404: t.Type<A4, C4>;
  500: t.Type<A5, C5>;
};

export function oidcExchangeDecoder<
  A0 = OidcExchangeTokenResponse,
  C0 = OidcExchangeTokenResponse,
  A1 = OidcExchangeOtpResponse,
  C1 = OidcExchangeOtpResponse,
  A2 = Problem,
  C2 = Problem,
  A3 = Problem,
  C3 = Problem,
  A4 = Problem,
  C4 = Problem,
  A5 = Problem,
  C5 = Problem
>(
  overrideTypes:
    | Partial<
        OidcExchangeResponsesT<A0, C0, A1, C1, A2, C2, A3, C3, A4, C4, A5, C5>
      >
    | t.Type<A0, C0>
    | undefined = {}
): r.ResponseDecoder<
  | r.IResponseType<200, A0, never>
  | r.IResponseType<201, A1, never>
  | r.IResponseType<400, A2, never>
  | r.IResponseType<403, A3, never>
  | r.IResponseType<404, A4, never>
  | r.IResponseType<500, A5, never>
> {
  const isDecoder = (d: any): d is t.Type<A0, C0> =>
    typeof d["_A"] !== "undefined";

  const type = {
    ...((oidcExchangeDefaultResponses as unknown) as OidcExchangeResponsesT<
      A0,
      C0,
      A1,
      C1,
      A2,
      C2,
      A3,
      C3,
      A4,
      C4,
      A5,
      C5
    >),
    ...(isDecoder(overrideTypes) ? { 200: overrideTypes } : overrideTypes)
  };

  const d200 = (type[200].name === "undefined"
    ? r.constantResponseDecoder<undefined, 200, never>(200, undefined)
    : r.ioResponseDecoder<
        200,
        typeof type[200]["_A"],
        typeof type[200]["_O"],
        never
      >(200, type[200])) as r.ResponseDecoder<r.IResponseType<200, A0, never>>;

  const d201 = (type[201].name === "undefined"
    ? r.constantResponseDecoder<undefined, 201, never>(201, undefined)
    : r.ioResponseDecoder<
        201,
        typeof type[201]["_A"],
        typeof type[201]["_O"],
        never
      >(201, type[201])) as r.ResponseDecoder<r.IResponseType<201, A1, never>>;

  const d400 = (type[400].name === "undefined"
    ? r.constantResponseDecoder<undefined, 400, never>(400, undefined)
    : r.ioResponseDecoder<
        400,
        typeof type[400]["_A"],
        typeof type[400]["_O"],
        never
      >(400, type[400])) as r.ResponseDecoder<r.IResponseType<400, A2, never>>;

  const d403 = (type[403].name === "undefined"
    ? r.constantResponseDecoder<undefined, 403, never>(403, undefined)
    : r.ioResponseDecoder<
        403,
        typeof type[403]["_A"],
        typeof type[403]["_O"],
        never
      >(403, type[403])) as r.ResponseDecoder<r.IResponseType<403, A3, never>>;

  const d404 = (type[404].name === "undefined"
    ? r.constantResponseDecoder<undefined, 404, never>(404, undefined)
    : r.ioResponseDecoder<
        404,
        typeof type[404]["_A"],
        typeof type[404]["_O"],
        never
      >(404, type[404])) as r.ResponseDecoder<r.IResponseType<404, A4, never>>;

  const d500 = (type[500].name === "undefined"
    ? r.constantResponseDecoder<undefined, 500, never>(500, undefined)
    : r.ioResponseDecoder<
        500,
        typeof type[500]["_A"],
        typeof type[500]["_O"],
        never
      >(500, type[500])) as r.ResponseDecoder<r.IResponseType<500, A5, never>>;

  return r.composeResponseDecoders(
    r.composeResponseDecoders(
      r.composeResponseDecoders(
        r.composeResponseDecoders(r.composeResponseDecoders(d200, d201), d400),
        d403
      ),
      d404
    ),
    d500
  );
}

// Decodes the success response with the type defined in the specs
export const oidcExchangeDefaultDecoder = () => oidcExchangeDecoder();

/****************************************************************
 * otpResend
 */

// Request type definition
export type OtpResendT = r.IPostApiRequestType<
  { readonly body?: OtpResendRequest | ReadableStream<Uint8Array> | Buffer },
  "Content-Type",
  never,
  | r.IResponseType<200, OidcExchangeOtpResponse, never>
  | r.IResponseType<400, Problem, never>
  | r.IResponseType<404, Problem, never>
  | r.IResponseType<409, Problem, never>
  | r.IResponseType<500, Problem, never>
>;

export const otpResendDefaultResponses = {
  200: OidcExchangeOtpResponse,
  400: Problem,
  404: Problem,
  409: Problem,
  500: Problem
};

export type OtpResendResponsesT<
  A0 = OidcExchangeOtpResponse,
  C0 = OidcExchangeOtpResponse,
  A1 = Problem,
  C1 = Problem,
  A2 = Problem,
  C2 = Problem,
  A3 = Problem,
  C3 = Problem,
  A4 = Problem,
  C4 = Problem
> = {
  200: t.Type<A0, C0>;
  400: t.Type<A1, C1>;
  404: t.Type<A2, C2>;
  409: t.Type<A3, C3>;
  500: t.Type<A4, C4>;
};

export function otpResendDecoder<
  A0 = OidcExchangeOtpResponse,
  C0 = OidcExchangeOtpResponse,
  A1 = Problem,
  C1 = Problem,
  A2 = Problem,
  C2 = Problem,
  A3 = Problem,
  C3 = Problem,
  A4 = Problem,
  C4 = Problem
>(
  overrideTypes:
    | Partial<OtpResendResponsesT<A0, C0, A1, C1, A2, C2, A3, C3, A4, C4>>
    | t.Type<A0, C0>
    | undefined = {}
): r.ResponseDecoder<
  | r.IResponseType<200, A0, never>
  | r.IResponseType<400, A1, never>
  | r.IResponseType<404, A2, never>
  | r.IResponseType<409, A3, never>
  | r.IResponseType<500, A4, never>
> {
  const isDecoder = (d: any): d is t.Type<A0, C0> =>
    typeof d["_A"] !== "undefined";

  const type = {
    ...((otpResendDefaultResponses as unknown) as OtpResendResponsesT<
      A0,
      C0,
      A1,
      C1,
      A2,
      C2,
      A3,
      C3,
      A4,
      C4
    >),
    ...(isDecoder(overrideTypes) ? { 200: overrideTypes } : overrideTypes)
  };

  const d200 = (type[200].name === "undefined"
    ? r.constantResponseDecoder<undefined, 200, never>(200, undefined)
    : r.ioResponseDecoder<
        200,
        typeof type[200]["_A"],
        typeof type[200]["_O"],
        never
      >(200, type[200])) as r.ResponseDecoder<r.IResponseType<200, A0, never>>;

  const d400 = (type[400].name === "undefined"
    ? r.constantResponseDecoder<undefined, 400, never>(400, undefined)
    : r.ioResponseDecoder<
        400,
        typeof type[400]["_A"],
        typeof type[400]["_O"],
        never
      >(400, type[400])) as r.ResponseDecoder<r.IResponseType<400, A1, never>>;

  const d404 = (type[404].name === "undefined"
    ? r.constantResponseDecoder<undefined, 404, never>(404, undefined)
    : r.ioResponseDecoder<
        404,
        typeof type[404]["_A"],
        typeof type[404]["_O"],
        never
      >(404, type[404])) as r.ResponseDecoder<r.IResponseType<404, A2, never>>;

  const d409 = (type[409].name === "undefined"
    ? r.constantResponseDecoder<undefined, 409, never>(409, undefined)
    : r.ioResponseDecoder<
        409,
        typeof type[409]["_A"],
        typeof type[409]["_O"],
        never
      >(409, type[409])) as r.ResponseDecoder<r.IResponseType<409, A3, never>>;

  const d500 = (type[500].name === "undefined"
    ? r.constantResponseDecoder<undefined, 500, never>(500, undefined)
    : r.ioResponseDecoder<
        500,
        typeof type[500]["_A"],
        typeof type[500]["_O"],
        never
      >(500, type[500])) as r.ResponseDecoder<r.IResponseType<500, A4, never>>;

  return r.composeResponseDecoders(
    r.composeResponseDecoders(
      r.composeResponseDecoders(r.composeResponseDecoders(d200, d400), d404),
      d409
    ),
    d500
  );
}

// Decodes the success response with the type defined in the specs
export const otpResendDefaultDecoder = () => otpResendDecoder();

/****************************************************************
 * otpVerify
 */

// Request type definition
export type OtpVerifyT = r.IPostApiRequestType<
  { readonly body?: OtpVerifyRequest | ReadableStream<Uint8Array> | Buffer },
  "Content-Type",
  never,
  | r.IResponseType<200, TokenResponse, never>
  | r.IResponseType<400, Problem, never>
  | r.IResponseType<403, OtpForbidden, never>
  | r.IResponseType<404, Problem, never>
  | r.IResponseType<409, Problem, never>
  | r.IResponseType<500, Problem, never>
>;

export const otpVerifyDefaultResponses = {
  200: TokenResponse,
  400: Problem,
  403: OtpForbidden,
  404: Problem,
  409: Problem,
  500: Problem
};

export type OtpVerifyResponsesT<
  A0 = TokenResponse,
  C0 = TokenResponse,
  A1 = Problem,
  C1 = Problem,
  A2 = OtpForbidden,
  C2 = OtpForbidden,
  A3 = Problem,
  C3 = Problem,
  A4 = Problem,
  C4 = Problem,
  A5 = Problem,
  C5 = Problem
> = {
  200: t.Type<A0, C0>;
  400: t.Type<A1, C1>;
  403: t.Type<A2, C2>;
  404: t.Type<A3, C3>;
  409: t.Type<A4, C4>;
  500: t.Type<A5, C5>;
};

export function otpVerifyDecoder<
  A0 = TokenResponse,
  C0 = TokenResponse,
  A1 = Problem,
  C1 = Problem,
  A2 = OtpForbidden,
  C2 = OtpForbidden,
  A3 = Problem,
  C3 = Problem,
  A4 = Problem,
  C4 = Problem,
  A5 = Problem,
  C5 = Problem
>(
  overrideTypes:
    | Partial<
        OtpVerifyResponsesT<A0, C0, A1, C1, A2, C2, A3, C3, A4, C4, A5, C5>
      >
    | t.Type<A0, C0>
    | undefined = {}
): r.ResponseDecoder<
  | r.IResponseType<200, A0, never>
  | r.IResponseType<400, A1, never>
  | r.IResponseType<403, A2, never>
  | r.IResponseType<404, A3, never>
  | r.IResponseType<409, A4, never>
  | r.IResponseType<500, A5, never>
> {
  const isDecoder = (d: any): d is t.Type<A0, C0> =>
    typeof d["_A"] !== "undefined";

  const type = {
    ...((otpVerifyDefaultResponses as unknown) as OtpVerifyResponsesT<
      A0,
      C0,
      A1,
      C1,
      A2,
      C2,
      A3,
      C3,
      A4,
      C4,
      A5,
      C5
    >),
    ...(isDecoder(overrideTypes) ? { 200: overrideTypes } : overrideTypes)
  };

  const d200 = (type[200].name === "undefined"
    ? r.constantResponseDecoder<undefined, 200, never>(200, undefined)
    : r.ioResponseDecoder<
        200,
        typeof type[200]["_A"],
        typeof type[200]["_O"],
        never
      >(200, type[200])) as r.ResponseDecoder<r.IResponseType<200, A0, never>>;

  const d400 = (type[400].name === "undefined"
    ? r.constantResponseDecoder<undefined, 400, never>(400, undefined)
    : r.ioResponseDecoder<
        400,
        typeof type[400]["_A"],
        typeof type[400]["_O"],
        never
      >(400, type[400])) as r.ResponseDecoder<r.IResponseType<400, A1, never>>;

  const d403 = (type[403].name === "undefined"
    ? r.constantResponseDecoder<undefined, 403, never>(403, undefined)
    : r.ioResponseDecoder<
        403,
        typeof type[403]["_A"],
        typeof type[403]["_O"],
        never
      >(403, type[403])) as r.ResponseDecoder<r.IResponseType<403, A2, never>>;

  const d404 = (type[404].name === "undefined"
    ? r.constantResponseDecoder<undefined, 404, never>(404, undefined)
    : r.ioResponseDecoder<
        404,
        typeof type[404]["_A"],
        typeof type[404]["_O"],
        never
      >(404, type[404])) as r.ResponseDecoder<r.IResponseType<404, A3, never>>;

  const d409 = (type[409].name === "undefined"
    ? r.constantResponseDecoder<undefined, 409, never>(409, undefined)
    : r.ioResponseDecoder<
        409,
        typeof type[409]["_A"],
        typeof type[409]["_O"],
        never
      >(409, type[409])) as r.ResponseDecoder<r.IResponseType<409, A4, never>>;

  const d500 = (type[500].name === "undefined"
    ? r.constantResponseDecoder<undefined, 500, never>(500, undefined)
    : r.ioResponseDecoder<
        500,
        typeof type[500]["_A"],
        typeof type[500]["_O"],
        never
      >(500, type[500])) as r.ResponseDecoder<r.IResponseType<500, A5, never>>;

  return r.composeResponseDecoders(
    r.composeResponseDecoders(
      r.composeResponseDecoders(
        r.composeResponseDecoders(r.composeResponseDecoders(d200, d400), d403),
        d404
      ),
      d409
    ),
    d500
  );
}

// Decodes the success response with the type defined in the specs
export const otpVerifyDefaultDecoder = () => otpVerifyDecoder();
